import React, { useState, useEffect } from 'react';
import { Calendar, MapPin, Loader2, Users, Award } from 'lucide-react';
import SectionTitle from './SectionTitle';
import Button from './Button';
import { ArrowRight } from 'lucide-react';
import config from '../utils/config';
import { Link } from 'react-router-dom';

const WorkSection = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch events from backend
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${config.url}/events`);
        if (!response.ok) {
          throw new Error('Failed to fetch events');
        }
        const data = await response.json();
        // Show recent events (last 4)
        const recentEvents = data
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 4);
        setEvents(recentEvents);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('कार्यक्रम डेटा लोड करने में समस्या आई है।');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('hi-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getEventStats = (event, index) => {
    const stats = [
      { icon: Users, text: 'कार्यक्रम', color: 'text-blue-600' },
      { icon: Award, text: 'उत्कृष्ट सेवा', color: 'text-green-600' },
      { icon: Users, text: 'सामाजिक कल्याण', color: 'text-purple-600' },
      { icon: Award, text: 'समुदाय विकास', color: 'text-orange-600' }
    ];
    return stats[index % stats.length];
  };

  if (loading) {
    return (
      <section id="work" className="w-full bg-gradient-to-br from-orange-50 to-yellow-50 py-8 px-4 md:px-16">
        <div className="container mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 leading-tight" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
            <span className="text-orange-600">हमारे </span>
            <span className="text-orange-400">कार्य</span>
    </h2>
          <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
            समाज के कल्याण के लिए निरंतर प्रयासरत - हमारे द्वारा किए गए महत्वपूर्ण कार्य
          </p>
          <div className="text-center">
            <Loader2 className="w-12 h-12 animate-spin text-orange-600 mx-auto mb-4" />
            <p className="text-lg text-gray-600" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>कार्यक्रम लोड हो रहा है...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="work" className="w-full bg-gradient-to-br from-orange-50 to-yellow-50 py-8 px-4 md:px-16">
        <div className="container mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 leading-tight" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
            <span className="text-orange-600">हमारे </span>
            <span className="text-orange-400">कार्य</span>
          </h2>
          <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
            समाज के कल्याण के लिए निरंतर प्रयासरत - हमारे द्वारा किए गए महत्वपूर्ण कार्य
          </p>
          <div className="text-center">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded max-w-md mx-auto">
              <p className="text-lg" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>{error}</p>
            </div>
          </div>
    </div>
  </section>
);
  }

  return (
    <section id="work" className="w-full bg-gradient-to-br from-orange-50 to-yellow-50 py-20 px-4 md:px-16">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <SectionTitle>हमारे कार्य</SectionTitle>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
            समाज के कल्याण के लिए निरंतर प्रयासरत - हमारे द्वारा किए गए महत्वपूर्ण कार्य
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-600 to-red-600 mx-auto mt-6 rounded-full"></div>
        </div>

        {events.length === 0 ? (
          <div className="text-center py-16">
            <div className="bg-white rounded-2xl p-8 shadow-lg max-w-md mx-auto">
              <div className="text-6xl mb-4">🏛️</div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>कोई कार्यक्रम नहीं मिला</h3>
              <p className="text-gray-500" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
                अभी तक कोई कार्यक्रम नहीं है। जल्द ही नए कार्यक्रमों की जानकारी यहाँ दिखाई देगी।
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
            {events.map((event, idx) => {
              const stats = getEventStats(event, idx);

              
              return (
                <div 
                  key={event.id} 
                  className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 relative group"
                >
                  {event.image_url && (
                    <div className="relative h-48 overflow-hidden">
                      <img 
                        src={`${config.url}${event.image_url}`} 
                        alt={event.title} 
                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/400x300?text=कार्यक्रम+छवि';
                        }}
                      />
                      {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      <div className="absolute top-4 left-4 bg-orange-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                        कार्यक्रम
                      </div> */}
                    </div>
                  )}
                  
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-bold text-lg text-gray-900 mb-3 line-clamp-2" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
                      {event.title}
                    </h3>
                    
                    <div className="space-y-2 mb-4">
                      <div className="flex items-center text-gray-600">
                        <Calendar className="w-4 h-4 mr-2 text-orange-500" />
                        <span className="text-sm font-medium" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
                          {formatDate(event.date)}
                        </span>
                      </div>
                      {event.location && (
                        <div className="flex items-center text-gray-600">
                          <MapPin className="w-4 h-4 mr-2 text-orange-500" />
                          <span className="text-sm" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
                            {event.location}
                          </span>
                        </div>
                      )}
                    </div>
                    
                    {event.description && (
                      <p className="text-gray-600 text-sm mb-4 line-clamp-3" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
                        {event.description}
                      </p>
                    )}
                    
                    <div className="mt-auto flex items-center justify-between">
                    
                      <div className="text-orange-600 text-xs font-semibold bg-orange-100 px-2 py-1 rounded-full">
                        {new Date(event.date).getFullYear()}
                      </div>
                    <Button to={`/karya/${event.id}`} size="sm" rightIcon={ArrowRight} variant="primary" className="mt-2">और पढ़ें</Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* View All Events Button */}
        {events.length > 0 && (
          <div className="text-center mt-12">
            <Link to="/karya" className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 py-2 rounded-full font-semibold text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300" style={{ fontFamily: 'Mukta, Arial, sans-serif' }}>
              सभी कार्यक्रम देखें
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default WorkSection; 